(ns machtfit.init
  (:require [goog]
            [machtfit.admin-employees :as admin-employees]
            [machtfit.budget-periods :as budget-periods]
            [machtfit.dashboard.stepchall.form.core :as stepchall.form]
            [machtfit.feature :as feature]
            [machtfit.health-expense.admin.detail :as health-expense.admin.detail]
            [machtfit.language :as language]
            [machtfit.place-order :as place-order]
            [machtfit.planned-commission :as planned-commission]
            [machtfit.product-form.views :as product-form.views]
            [machtfit.responsive :as responsive]
            [machtfit.settlement-recipients.core :as settlement-recipients]
            [machtfit.startpage.views :as startpage.views]
            [machtfit.subsidy-rate :as subsidy-rate]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [reagent.dom.client :as rdc]))

(def ^:private debug?
  ^boolean goog/DEBUG)

(rf/reg-sub ::is-spa?
  (fn [db _]
    (:is-spa? db)))

(defn- dev-setup []
  (when debug?
    (enable-console-print!)))

(defn error-boundary [_component]
  (let [error (r/atom nil)]
    (r/create-class
     {:get-derived-state-from-error (fn [e]
                                      (reset! error e)
                                      #js {})
      :reagent-render (fn [component]
                        (if (and @error (not js/goog.DEBUG))
                          [startpage.views/error-panel]
                          [component]))})))

(defonce roots (atom {}))

(defn- get-or-create-root! [view-id element]
  (or (get @roots view-id)
      (let [root (rdc/create-root element)]
        (swap! roots assoc view-id root)
        root)))

(defn- mount-root []
  (rf/clear-subscription-cache!)
  (let [mf-views (js/document.querySelectorAll "[data-mf-view]")]
    (doseq [element mf-views
            :let [view-id (.getAttribute element "data-mf-view")
                  root-component (case view-id
                                   "company" settlement-recipients/company
                                   "health-expense-detail" health-expense.admin.detail/health-expense-detail
                                   "place-order" place-order/place-order
                                   "product-edit" product-form.views/product-edit
                                   "startpage" startpage.views/startpage
                                   "stepchall-edit" stepchall.form/stepchall-edit
                                   "subsidy-rate" subsidy-rate/subsidy-rate
                                   "budget-periods" budget-periods/main
                                   "supplier-detail" planned-commission/supplier-detail
                                   "user-detail" admin-employees/user-detail
                                   ;;
                                   )
                  root (get-or-create-root! view-id element)]]
      (if root-component
        (rdc/render root [error-boundary root-component])
        (let [message (str "No root-component registered for mf-view " view-id)]
          (js/console.error message)
          (when debug?
            (rdc/render root [:div message])))))))

(defn ^:export init []
  (dev-setup)
  (rf/dispatch-sync [::feature/load-django-flags])
  (rf/dispatch-sync [::language/init])
  (rf/dispatch-sync [::responsive/init-or-update-grid-tier])
  (mount-root))
